const initialState = {
  user: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_MY_ACCOUNT': {
      const { user } = payload;
      return {
        ...state,
        user,
      };
    }
    case 'SET_GENERATED_MULTI_FACTOR': {
      const { secret, qrCode } = payload;
      return {
        ...state,
        secret,
        qrCode,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MultiFactor/MultiFactor.reducer.js